import React from 'react';
// import { Modal, Container, Row, Col } from 'reactstrap';
import { Modal, Container, Row } from 'reactstrap';
import QRCode from 'qrcode.react';

import { withNamespaces } from 'react-i18next';

import { ApiContext } from 'src/utils/ApiContext';

export default withNamespaces()(ModalQR);
function ModalQR(props) {
  const { t } = props;
  const context = React.useContext(ApiContext);

  const { Show, Title, Value, FileName } = context.ModalQR;
  var data = context.ModalQR;

  // 判斷是否顯示跳轉按鈕
  let showJumbButton = false;
  if (Value.search('http') !== -1) {
    showJumbButton = true;
  }

  return (
    <Modal
      isOpen={Show}
      toggle={() => data.Show = false && context.setShowQR(data)}
      zIndex={1}
    >
      <Container style={{ padding: 20, background: '#ffffff' }}>
        {Title && <Row className={'justify-content-center align-items-center'}>
          <p>{Title}</p>
        </Row>}
        <Row className={'justify-content-center align-items-center'}>
          <div
            onClick={() => {
              window.location.href = Value;
            }}
          >
            <QRCode value={Value} level="L" includeMargin={true} />
          </div>
        </Row>
        <Row className={'justify-content-center align-items-center'}>
          <div className="m-2" />
          <button
            className={'btn btn-outline-success my-2'}
            onClick={() => {
              document.getElementsByTagName('canvas')[0].toBlob((blob) => {
                const url = window.URL.createObjectURL(blob);

                const a = document.createElement('a');
                a.style.display = 'none';
                a.download = `${FileName}.png`;
                a.href = url;
                document.body.appendChild(a);
                a.click();
                window.URL.revokeObjectURL(url);
              });
            }}
          >
            {t('ModalQR.Download')}
          </button>

          <div className="m-2" />
          {showJumbButton &&
            <button
              className={'btn btn-outline-success my-2'}
              onClick={() => {
                const winRef = window.open('', '_blank');
                winRef.location = Value;
              }}
            >
              {t('ModalQR.Redirect')}
            </button>
          }
        </Row>
      </Container>
    </Modal>
  );
};
